/* unplugin-vue-components disabled */import { render } from "./ParameterData.vue?vue&type=template&id=8faf47b0"
import script from "./ParameterData.vue?vue&type=script&lang=js"
export * from "./ParameterData.vue?vue&type=script&lang=js"

import exportComponent from "/myfunnl/isspadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__